import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Vishwastha from "../../components/public/vishwastha";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"विश्वस्त मंडळ"} content={<Vishwastha />} />
      <Footer />
    </>
  );
};
